
const DEVELOPMENT = process.env.NODE_ENV !==  'production'

const devDirective = (el, bindings, vnode) => {
  if (!DEVELOPMENT) {
    el.style.display = 'none'
  }
}

export default {
  install(Vue) {

    Vue.directive('hide-in-production', devDirective)
  }
}



// WEBPACK FOOTER //
// ./src/plugins/developmentUtils/index.js